import '../sass/base.sass';
import { loadLazyVideo } from './functions';

document.addEventListener("DOMContentLoaded", () => {
    const logoutButtons = document.querySelectorAll(".js-logout");
    logoutButtons.forEach(logoutButton => {
        logoutButton.addEventListener('click', async () => {
            await fetch('/logout');
            window.location.href = '/';
        });
    })

    const userMenuIcon = document.querySelector("#js-user-menu") as HTMLElement|null;
    const userMenu = document.querySelector("#js-desktop-menu") as HTMLElement|null;

    if (null !== userMenuIcon && null !== userMenu) {
        userMenuIcon.addEventListener("mouseover", () => {
            userMenu.classList.add("active");
            const rect = userMenuIcon.getBoundingClientRect();
            userMenu.style.right = `${window.innerWidth - rect.right - rect.width}px`;
        });
        userMenu.addEventListener("mouseleave", () => {
            userMenu.classList.remove("active");
        });
    }

    const lazyVideos = [].slice.call(document.querySelectorAll("video.lazy"));

    if ("IntersectionObserver" in window) {
        const lazyVideoObserver = new IntersectionObserver(function(entries) {
            entries.forEach(function (video) {
                if (video.isIntersecting) {
                    loadLazyVideo(video.target as HTMLVideoElement);
                    lazyVideoObserver.unobserve(video.target);
                }
            });
        });

        lazyVideos.forEach(function (lazyVideo: HTMLVideoElement) {
            lazyVideoObserver.observe(lazyVideo);
        });
    }

    document.addEventListener("click", async (e) => {
        const el = e.target as HTMLElement;
        if (el.classList.contains("js-sound-button")) {
            const target = document.querySelector(el.dataset.target) as HTMLVideoElement|null;
            if (target) {
                target.muted = !target.muted;
            }
            const soundSvgs = [].slice.call(el.querySelectorAll("img"));
            soundSvgs.forEach((soundSvg: SVGElement) => soundSvg.classList.toggle("active"));
        } else if (el.classList.contains("infinite-scroll")) {
            e.preventDefault();
            const target = document.querySelector(el.dataset.target) as HTMLElement|null;
            if (target) {
                const response = await fetch((el as HTMLLinkElement).href);
                if (200 === response.status) {
                    const data = await response.text();
                    const parentElement = el.parentElement;
                    el.remove();
                    if (parentElement.innerHTML.trim().length === 0) {
                        parentElement.remove();
                    }
                    target.insertAdjacentHTML('beforeend', data);
                }
            }
        }
    })
   // Au chargement, marque les inputs password et permet de les rendre visible via un bouton
   document.querySelectorAll('input[type="password"]').forEach(input => {
       input.classList.add('password-viewable');

       const wrapper = document.createElement('div');
       wrapper.className = 'password-wrapper';

       const toggle = document.createElement('span');
       toggle.className = 'password-toggle';
       toggle.innerHTML = '<img src="/sooner/svg/eye-open.svg" alt="Basculer la visibilité du mot de passe" />';

       input.parentNode.insertBefore(wrapper, input);
       wrapper.appendChild(input);
       wrapper.appendChild(toggle);

       toggle.addEventListener('click', () => {
           const inp = input as HTMLInputElement;
           const img = toggle.querySelector('img');

           inp.type = inp.type === 'password' ? 'text' : 'password';
           img.src = inp.type === 'password' 
               ? '/sooner/svg/eye-open.svg' 
               : '/sooner/svg/eye-closed.svg';
       });
   });
  document.querySelectorAll<HTMLAnchorElement>('header nav a').forEach((link: HTMLAnchorElement) => {
      const linkPath = new URL(link.href).pathname;
      const currentPath = window.location.pathname;

      // Exact match
      if(linkPath === currentPath) {
          link.classList.add('active');
      }
  });

    const modalTogglers: NodeListOf<HTMLElement> = document.querySelectorAll('.js-modal-toggler');
    modalTogglers.forEach(function (modalToggler) {
        modalToggler.addEventListener('click', function (e) {
            e.preventDefault();
            const targetSelectors = modalToggler.dataset.target.split(',');
            targetSelectors.forEach(function (targetSelector) {
                const target = document.querySelector(targetSelector);
                if (target) {
                    target.classList.toggle('open');
                }
            });
        });
    });
});
